import {Socket} from "phoenix";
//import { EmojiButton } from '@joeattardi/emoji-button';
//import twemoji from 'twemoji';

let userSocket        = null
let channel           = null
let chatInput         = null
let messagesContainer = null

function initSendMessageInput(EmojiButton) {
  let input = this.el.querySelector('input')
  let button = this.el.querySelector('button[js-id=send-message]')

  const picker = new EmojiButton({
    //style: 'twemoji'
    initialCategory: 'recents'
  });
  let roomId = input.dataset.roomId;
  let type = input.dataset.type;
  let trigger = this.el.querySelector('emojipicker')
  picker.on('emoji', selection => {
    input.value = input.value + selection.emoji + " "
  });
  trigger.addEventListener('click', () => picker.togglePicker(trigger));

  input.addEventListener("keypress", event => {
    if(event.key === 'Enter' && input.value != ""){
      this.pushEvent("send_message", {body: input.value, room_id: roomId, type: type})
      input.value = ""
    } else {
      if (this.el.dataset.blockGuests == "true"){
        this.el.parentElement.querySelector("[js-id=chat-signup-required]").classList.remove('hidden')
      }
    }
  })
  button.addEventListener('click', event => {
    if (input.value != "" ){
      this.pushEvent("send_message", {body: input.value, room_id: roomId, type: type})
      input.value = ""
    }
  })
}
async function getEmojiComponents(){
  const { EmojiButton } = await import("@joeattardi/emoji-button")
  return EmojiButton
}

const ChatFontSize = {
  mounted(){
    console.log("ChatFontSize mounted")
    let increaseButton = this.el.parentElement.querySelector("[js-id=increase_font]")
    let decreaseButton = this.el.parentElement.querySelector("[js-id=decrease_font]")
    let messagesContainer = this.el
    let fontSize = window.localStorage.getItem("chatFontSize") || 16
    //messagesContainer.style.fontSize = fontSize + "px"
    this.pushEventTo(this.el, "change_font_size", {new_size: fontSize})
    increaseButton.addEventListener('click', () => {
      let fontSize = window.localStorage.getItem("chatFontSize") || 16
      let newSize = parseInt(fontSize) + 1
      //messagesContainer.style.fontSize = newSize + "px"
      this.pushEventTo(this.el, "change_font_size", {new_size: newSize})
      window.localStorage.setItem("chatFontSize", newSize)
      decreaseButton.disabled = ""
    })
    decreaseButton.addEventListener('click', () => {
      let fontSize = window.localStorage.getItem("chatFontSize") || 16
      let newSize = parseInt(fontSize) - 1
      //messagesContainer.style.fontSize = newSize + "px"
      this.pushEventTo(this.el, "change_font_size", {new_size: newSize})
      window.localStorage.setItem("chatFontSize", newSize)
      if (newSize < 10) {
        decreaseButton.disabled = "disabled"
      }
    })
  }
}

const ChatInputHook = {
  mounted() {
    getEmojiComponents().then((EmojiButton) => {
      initSendMessageInput.bind(this)(EmojiButton)
    })
  },
  disconnected() { console.log('disconnected') },
  reconnected() { console.log('reconnected') },
  updated() { console.log('updated') },
  destroyed() {
    console.log('destroyed')
    this.el.remove()
  }
}

const OfflineChatInputHook = {
  mounted() {
    let input = this.el.querySelector('textarea[jsid=offline-chat-input]')
    input.addEventListener('keypress', (event) => {
      if(event.key === 'Enter' && input.value != ""){
        this.el.querySelector('button[type=submit]').click()
      }
    })
    input.focus()
  },
  disconnected() { console.log('disconnected') },
  reconnected() { console.log('reconnected') },
  updated() { console.log('updated') },
  destroyed() { console.log('destroyed') }

}

const PrivateChatBox = {
  mounted() {
    let minimizeButton = this.el.querySelector('[js-id=minimizeButton]')
    minimizeButton.addEventListener('click', () => {
      this.el.classList.toggle('minimized')
    })
  },
  disconnected() { console.log('PrivateChatBox disconnected') },
  reconnected()  { console.log('PrivateChatBox reconnected') },
  updated()      { console.log('PrivateChatBox updated') },
  destroyed()    { console.log('PrivateChatBox destroyed') }
}

const ChatScrollTop = {
  mounted() {
    console.log("ChatScrollTop mounted")
    //this.el.parentElement.scrollTop = 0
    this.el.classList.add("transform")
    setTimeout(() => {
      this.el.classList.remove("translate-x-full")
      this.el.classList.remove("-translate-x-full")
      setTimeout(() => {
        this.el.classList.remove("transform")
        this.el.parentElement.scrollTop = 0
      }, 1500)
    }, 10)
    //twemoji.parse(this.el);
  },
  destroyed()    { console.log('ChatScrollTop destroyed') }
}

export default { ChatInputHook, ChatScrollTop, ChatFontSize, PrivateChatBox, OfflineChatInputHook};

